<template>
  <div class="bigscreen">
    <button class="bigscreen-back" type="button" @click="goBackHome">
      <i class="el-icon-arrow-left"></i>
      <span>返回首页</span>
    </button>

    <el-row :gutter="16" class="full">
      <el-col :span="20" class="left">
        <el-row>
          <el-card class="toolbar" shadow="never">
            <el-form :model="filters" inline label-width="80px" size="small">
              <el-form-item label="时间范围">
                <el-date-picker v-model="filters.range" type="datetimerange" start-placeholder="开始时间"
                  end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions"
                  align="right" @change="onRangeChange" />
              </el-form-item>
              <el-form-item label="房间">
                <el-select v-model="filters.room" placeholder="全部房间" filterable clearable>
                  <el-option v-for="room in rooms" :key="room.value" :label="room.label" :value="room.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="来源">
                <el-select v-model="filters.source" placeholder="全部来源" filterable clearable>
                  <el-option v-for="src in sources" :key="src.value" :label="src.label" :value="src.value" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleQuery">查询</el-button>
                <el-button @click="handleReset">重置</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-row>


        <el-alert v-if="error" type="warning" :closable="false" class="error-alert">
          {{ error }}
        </el-alert>

        <div v-loading.fullscreen.lock="loading" style="position:relative;"
          element-loading-background="rgba(5,11,26,0.85)" element-loading-custom-class="my-loading"
          element-loading-text="加载中...">
          <el-row :gutter="30">
            <el-col :span="6">
              <el-card class="panel watch-card" shadow="always">
                <div slot="header" class="panel-title">观看</div>
                <div class="watch-items">
                  <div class="watch-item">
                    <span class="watch-label">观看达 3 秒的次数</span>
                    <span class="watch-value">{{ formatNumber(watchMetrics.watch3s) }}</span>
                  </div>
                  <div class="watch-item">
                    <span class="watch-label">观看达 15 秒的次数</span>
                    <span class="watch-value">{{ formatNumber(watchMetrics.watch15s) }}</span>
                  </div>
                  <div class="watch-item">
                    <span class="watch-label">观看达 60 秒的次数</span>
                    <span class="watch-value">{{ formatNumber(watchMetrics.watch60s) }}</span>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="18">
              <el-row :gutter="12" class="kpi-row">
                <el-col v-for="item in kpis" :key="item.key" :span="6">
                  <el-card class="panel kpi-card" shadow="hover">
                    <div class="kpi-label">{{ item.label }}</div>
                    <div class="kpi-value">
                      {{ item.key == 'danmuTotal' ? danmuTotal : item.value }}
                    </div>
                    <div class="kpi-delta" :class="{ up: item.delta >= 0, down: item.delta < 0 }">
                      <span v-if="item.delta >= 0">▲</span>
                      <span v-else>▼</span>
                      {{ formatDelta(item.delta) }}%
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </el-col>

          </el-row>




          <el-row :gutter="20">
            <el-col :span="8">
              <el-card class="panel chart-card" shadow="always">
                <div slot="header" class="panel-header">
                  <div class="panel-title">实时观看趋势</div>
                  <div class="panel-substats">
                    <span>播放成功率 <strong>{{ formatPercent(successRates.playback) }}</strong></span>
                    <span>弹幕成功率 <strong>{{ formatPercent(successRates.danmaku) }}</strong></span>
                  </div>
                </div>
                <EChartsBox :option="lineOption" height="280px" />
              </el-card>
            </el-col>
            <el-col :span="16">
              <el-card class="panel chart-card" shadow="always">
                <div slot="header" class="panel-header">
                  <div class="panel-title">播放成功率（维度组合）</div>
                  <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">
                    <el-select v-model="successDim" size="mini" style="width:130px">
                      <el-option label="按地区查看" value="region" />
                      <el-option label="按系统查看" value="os" />
                      <el-option label="按浏览器查看" value="browser" />
                      <el-option label="按平台查看" value="platform" />
                    </el-select>
                    <el-select v-model="filterRegion" size="mini" multiple collapse-tags clearable placeholder="地区筛选"
                      style="width:100px">
                      <el-option v-for="opt in filterOptions.region" :key="opt" :label="opt" :value="opt" />
                    </el-select>
                    <el-select v-model="filterOS" size="mini" multiple collapse-tags clearable placeholder="系统筛选"
                      style="width:100px">
                      <el-option v-for="opt in filterOptions.os" :key="opt" :label="opt" :value="opt" />
                    </el-select>
                    <el-select v-model="filterPlatform" size="mini" multiple collapse-tags clearable placeholder="平台筛选"
                      style="width:100px">
                      <el-option v-for="opt in filterOptions.platform" :key="opt" :label="opt" :value="opt" />
                    </el-select>
                    <el-select v-model="filterBrowser" size="mini" multiple collapse-tags clearable placeholder="浏览器筛选"
                      style="width:100px">
                      <el-option v-for="opt in filterOptions.browser" :key="opt" :label="opt" :value="opt" />
                    </el-select>
                  </div>
                </div>
                <EChartsBox :option="playinfoOption" height="280px" />

              </el-card>
            </el-col>
          </el-row>

          <el-row :gutter="12" class="chart-grid">
            <el-col :span="12">
              <el-card class="panel chart-card" shadow="always">
                <div slot="header" class="panel-title">IP 地区占比</div>
                <EChartsBox :option="regionOption" height="260px" />
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="panel chart-card" shadow="always">
                <div slot="header" class="panel-title">浏览器占比</div>
                <EChartsBox :option="browserOption" height="260px" />
              </el-card>
            </el-col>
          </el-row>

          <el-card class="panel table-card" shadow="always">
            <div slot="header" class="panel-title">3秒内无效 / 未知明细</div>
            <el-table :data="abnormalList" size="small" height="500" stripe empty-text="暂无异常记录">
              <el-table-column prop="timestamp" label="时间" min-width="130" />
              <el-table-column prop="ip" label="IP" min-width="120" />
              <el-table-column prop="region" label="地区" min-width="140" />
              <el-table-column prop="device" label="终端" min-width="120" />
              <el-table-column prop="reason" label="原因" min-width="180" show-overflow-tooltip />
            </el-table>
          </el-card>
        </div>

      </el-col>

      <el-col :span="4" class="right">
        <el-card class="panel video-panel" shadow="always">
          <div slot="header" class="panel-title">直播 / 回放</div>
          <div class="video-wrap" :class="{ empty: !videoSrc }">
            <template v-if="videoSrc">
              <div ref="agoraContainer" class="agora-container">
                <!-- Agora 远端视频会渲染在这里 -->
              </div>
              <div v-if="!remoteJoined" class="agora-placeholder">
                等待主播开播...
              </div>
            </template>
            <div v-else class="agora-placeholder" style="text-align: center;margin-top: 30px;">
              已结束
            </div>
          </div>
        </el-card>

        <el-card class="panel danmaku-panel-box" shadow="always">
          <div slot="header" class="panel-title">弹幕</div>
          <div v-if="roomId" class="danmaku-wrap">
            <Danmaku :key="roomId" :url="danmakuUrl" :room-id="danmu_roomId" :token="token" :watcher="true"
              :danmuTotal.sync="danmuTotal" />
          </div>
          <div v-else class="danmaku-empty">请选择房间以加载弹幕</div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import EChartsBox from '@/components/EChartsBox.vue'
import Danmaku from '@/components/Danmaku.vue'
import { liveroomsList,getAppid } from '@/api'
import { getToken } from '@/utils/auth'
import { requestAgoraRtcToken } from '@/utils/agora-token'
import {
  LIVE_STATS_PATHS,
  LEGACY_LIVE_STATS_PATHS,
  buildLiveStatsUrl,
  fetchLiveStatsJsonWithFallback,
} from '@/utils/live-stats-api'
import AgoraRTC from 'agora-rtc-sdk-ng'

const DEFAULT_STATS_BASE = process.env.NODE_ENV == 'production' ? 'https://anal.wokfoy.com' : 'http://127.0.0.1:3111'
const DANMAKU_WS = 'wss://danmuadmin.wokfoy.com:9981/b'
const DEFAULT_POSTER = 'https://via.placeholder.com/640x360/0d1a2f/0f9dff?text=Live+Preview'

export default {
  name: 'BigScreen',
  components: { EChartsBox, Danmaku },
  data() {
    return {
      successDim: 'platform',
      filterRegion: [],
      filterOS: [],
      filterPlatform: [],
      filterBrowser: [],
      filterOptions: { region: [], os: [], platform: [], browser: [] },
      visitsRaw: [],

      loading: false,
      error: '',
      apiBase: DEFAULT_STATS_BASE,
      filters: {
        range: [],
        room: '',
        source: ''
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近1小时',
            onClick: picker => {
              const end = new Date()
              const start = new Date(end.getTime() - 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '今天',
            onClick: picker => {
              const end = new Date()
              const start = new Date(new Date().setHours(0, 0, 0, 0))
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三天',
            onClick: picker => {
              const end = new Date()
              const start = new Date(end.getTime() - 3 * 24 * 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick: picker => {
              const end = new Date()
              const start = new Date(end.getTime() - 7 * 24 * 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近半个月',
            onClick: picker => {
              const end = new Date()
              const start = new Date(end.getTime() - 15 * 24 * 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick: picker => {
              const end = new Date()
              const start = new Date(end.getTime() - 30 * 24 * 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick: picker => {
              const end = new Date()
              const start = new Date(end.getTime() - 3 * 30 * 24 * 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近半年',
            onClick: picker => {
              const end = new Date()
              const start = new Date(end.getTime() - 6 * 30 * 24 * 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      rooms: [{ label: '全部房间', value: '' }],
      sources: [
        { label: '全部来源', value: '' },
        { label: 'tiktok', value: 'tiktok' },
        { label: 'facebook', value: 'facebook' },
        { label: 'youtube', value: 'youtube' },
        { label: 'pinterest', value: 'pinterest' },
        { label: 'ins', value: 'instagram' },
        { label: 'X', value: 'X' },
        { label: 'snap', value: 'snap' },
      ],
      kpis: [
        { key: 'uv', label: 'UV', value: '0', delta: 0 },
        { key: 'pv', label: 'PV', value: '0', delta: 0 },
        { key: 'pullSuccessRate', label: '拉流成功率', value: '0%', delta: 0 },
        { key: 'avgPullSeconds', label: '平均拉流秒数', value: '0.0s', delta: 0 },
        { key: 'danmuTotal', label: '弹幕总数', value: 0, delta: 0 },
        { key: 'shoppingCartTotal', label: '购物车点击', value: 0, delta: 0 },
        { key: 'contactTotal', label: '联系客服点击', value: 0, delta: 0 }
      ],
      danmuTotal: 0,
      watchMetrics: { watch3s: 0, watch15s: 0, watch60s: 0 },
      chartData: {
        watchTrend: { timestamps: [], values: [] },
        sourceBar: { categories: [], series: [] },
        devicePie: [],
        regionBar: { categories: [], series: [] },
        browserPie: []
      },
      lineOption: {},
      barOption: {},
      deviceOption: {},
      regionOption: {},
      browserOption: {},
      abnormalList: [],
      successRates: { playback: 0, danmaku: 0 },
      videoSrc: '',
      poster: DEFAULT_POSTER,
      hls: null,
      roomId: '',
      danmu_roomId: '',
      danmakuUrl: DANMAKU_WS,

      // === Agora 相关状态 ===
      agoraClient: null,
      remoteJoined: false,
      agora: {
        appId: '656131426d3845acadd7c7e18bf2e19a',
        token: null, // TODO: 从后台获取或在此处填入观众 token（如果开启了鉴权）
        uid: null,
        uidMode: ''
      },
      joining: false,
      joinedChannel: '',
      joinSeq: 0,
      loadingToken: false,
      tokenServer: process.env.NODE_ENV === "production" ? 'https://anal.wokfoy.com/rtcToken' : '/rtcToken',
      // === SSE 实时更新（增量事件） ===
      sse: null,
      visitIndex: null,
      recomputeTimer: null,
      recomputeDelayMs: 500,
      isRealtime: true,
      wokfoy_appid:''
    }
  },
  async mounted() {
    let { data: apps } = await getAppid()
    this.wokfoy_appid = apps[0].id
    this.initFilters()
    await this.loadRooms()
    await this.loadDashboardData()
    this.startSSE()
  },
  beforeDestroy() {
    this.leaveAgoraChannel()
    this.closeSSE()
  },
  computed: {
    token() {
      return this.$store.getters.token || localStorage.getItem('lvtu_live_apitoken') || getToken()
    },
    activeRoomId() {
      return this.filters.room || this.roomId || ''
    },
    // 组合筛选 + 维度分组 饼图
    playinfoOption() {
      return this.BuildPlayInfoOption(
        this.visitsRaw,
        this.successDim,
        {
          region: this.filterRegion,
          os: this.filterOS,
          platform: this.filterPlatform,
          browser: this.filterBrowser,
        }
      )
    },
  },
  watch: {
    // videoSrc() {
    //   this.$nextTick(this.setupVideo)
    // },
    videoSrc: {
      handler(newVal, oldVal) {
        const n = (newVal || '').trim()
        const o = (oldVal || '').trim()
        if (!n || n === o) return
        clearTimeout(this._joinTimer)
        this._joinTimer = setTimeout(() => this.joinAgoraChannel(n), 300)
      }
    },
    'filters.room'(next) {
      const room = next || this.roomId
      this.updateVideoSource(room)
    },
    '$route.query.room'(next) {
      const normalized = String(next || '').trim()
      if (normalized && normalized !== this.filters.room) {
        this.filters.room = normalized
      }
    }
  },
  methods: {
    goBackHome() {
      this.$router.push('/')
    },
    // === 维度解析/过滤 ===
    bucketUSRegion(country, region) {
      const east = new Set(['ME', 'NH', 'VT', 'MA', 'RI', 'CT', 'NY', 'NJ', 'PA', 'DE', 'MD', 'DC', 'VA', 'NC', 'SC', 'GA', 'FL', 'WV']);
      const west = new Set(['WA', 'OR', 'CA', 'NV', 'ID', 'MT', 'WY', 'UT', 'AZ', 'AK', 'HI', 'CO', 'NM']);
      if ((country || '').toUpperCase() !== 'US') return '其他';
      const code = (region || '').toUpperCase();
      if (west.has(code)) return '美国西部';
      if (east.has(code)) return '美国东部';
      return '其他';
    },
    detectOS(v) {
      const ua = (v.ua || v.user_agent || '').toLowerCase();
      if (/iphone|ipad|ios/.test(ua)) return 'ios';
      if (/android/.test(ua)) return '安卓';
      if (/winfow/.test(ua)) return 'Window';
      return '其他';
    },
    detectPlatform(v) {
      const ref = (v.referer || '').toLowerCase();
      const extra = v.extra_json || {};
      const utm = String(extra.utm_source || extra.source || '').toLowerCase();
      const s = utm || ref;
      if (/tiktok|ttq|utm_source=tk|utm_source=tiktok/.test(s)) return 'tiktok';
      if (/pin|pinterest|utm_source=pinterest|utm_source=pin/.test(s)) return 'pinterest';
      if (/youtube|youtu\.be|utm_source=yt|utm_source=youtube/.test(s)) return 'youtube';
      if (/instagram|ins/.test(s)) return 'ins';
      if (/snap/.test(s)) return 'Snap';
      if (/X|twitter/.test(s)) return 'X';
      return '其他';
    },
    bucketBrowser(v) {
      return this.detectBrowser(v)
    },
    detectPlayinfo(visit = {}) {
      const extra = visit.extra_json || {};
      const s = String(extra.playinfo || extra.player || extra.protocol || visit.referer || '').toLowerCase();
      if (/hls|m3u8/.test(s)) return 'HLS';
      if (/dash|mpd/.test(s)) return 'DASH';
      if (/mp4/.test(s)) return 'MP4';
      if (/flv/.test(s)) return 'FLV';
      return '其他';
    },
    buildFilterOptionsFromVisits(visits = []) {
      const rows = visits.map(v => ({
        region: this.bucketUSRegion((v.country || v.geo_country || ''), (v.region || v.geo_region || '')),
        os: this.detectOS(v),
        platform: this.detectPlatform(v),
        browser: this.bucketBrowser(v),
      }));
      return {
        region: Array.from(new Set(rows.map(x => x.region))),
        os: Array.from(new Set(rows.map(x => x.os))),
        platform: Array.from(new Set(rows.map(x => x.platform))),
        browser: Array.from(new Set(rows.map(x => x.browser))),
      };
    },

    initFilters() {
      const end = new Date()
      const start = new Date(end.getTime() - 12 * 60 * 60 * 1000)
      this.filters.range = [this.formatDateTime(start), this.formatDateTime(end)]
      this.isRealtime = true
    },
    onRangeChange(range, meta) {
      this.filters.range = range

      const now = Date.now()
      const start = this.parseTimestamp(range?.[0])
      const end = this.parseTimestamp(range?.[1])

      // 1) 如果组件能告诉你是“快捷选项”，直接判定为实时
      // 不同组件字段名不同，你可以 console.log(meta) 看一下
      const pickedByShortcut =
        meta?.shortcut || meta?.isShortcut || meta?.source === 'shortcut' || meta?.type === 'shortcut'

      if (pickedByShortcut) {
        this.isRealtime = true
        return
      }

      // 2) 如果没有 meta：用 end 是否“贴近现在”判断
      // end 跟 now 很接近（< 60秒）就认为用户想看实时
      const endNearNow = end && Math.abs(now - end) < 12 * 60 * 60 * 1000
      if (endNearNow) {
        this.isRealtime = true
        return
      }

      // 3) 其它情况：认为是固定区间（历史）
      this.isRealtime = false
    },
    async handleQuery() {
      this.$emit('query', { ...this.filters })
      this.closeSSE()
      await this.loadDashboardData()
      this.startSSE()
    },
    async handleReset() {
      this.filters.room = ''
      this.filters.source = ''
      this.initFilters()
      this.$emit('reset')
      this.closeSSE()
      await this.loadDashboardData()
      this.startSSE()
    },
    formatDelta(delta) {
      const val = Number(delta || 0)
      return Math.abs(val).toFixed(1)
    },
    formatPercent(value) {
      const num = Number(value)
      if (Number.isNaN(num)) return '--'
      return `${num.toFixed(1)}%`
    },
    normalizeValue(value, key) {
      if (value === null || value === undefined || value === '') {
        if (key === 'pullSuccessRate') return '0%'
        if (key === 'avgPullSeconds') return '0.0s'
        return '0'
      }
      if (typeof value === 'number') {
        if (key === 'pullSuccessRate') return `${value.toFixed(1)}%`
        if (key === 'avgPullSeconds') return `${value.toFixed(1)}s`
        return value.toLocaleString()
      }
      return value
    },
    setKpis(payload = []) {
      let source
      if (Array.isArray(payload)) {
        source = payload
      } else if (payload && typeof payload === 'object') {
        source = this.kpis.map(k => {
          const patch = payload[k.key] || payload[k.label]
          if (patch === undefined) return k
          if (typeof patch === 'object' && !Array.isArray(patch)) {
            return { ...k, ...patch }
          }
          return { ...k, value: patch }
        })
      } else {
        source = this.kpis
      }

      this.kpis = source.map(item => {
        const key = item.key || item.label || ''
        const label = item.label || item.key || ''
        const value = this.normalizeValue(item.value, key)
        const delta = Number(item.delta ?? 0)
        return { key, label, value, delta }
      })
    },
    setChartData(payload = {}) {
      if (payload.watchTrend) this.chartData.watchTrend = payload.watchTrend
      if (payload.sourceBar) this.chartData.sourceBar = payload.sourceBar
      if (payload.devicePie) this.chartData.devicePie = payload.devicePie
      if (payload.regionBar) this.chartData.regionBar = payload.regionBar
      if (payload.browserPie) this.chartData.browserPie = payload.browserPie
      if (payload.playinfoPie) this.chartData.playinfoPie = payload.playinfoPie

      this.lineOption = this.buildWatchTrendOption(this.chartData.watchTrend)
      this.barOption = this.buildSourceOption(this.chartData.sourceBar)
      this.deviceOption = this.buildDeviceOption(this.chartData.devicePie)
      this.regionOption = this.buildRegionOption(this.chartData.regionBar)
      this.browserOption = this.buildBrowserOption(this.chartData.browserPie)

      if (payload.successRates) {
        this.setSuccessRates(payload.successRates)
      }
    },
    setAbnormalList(list = []) {
      this.abnormalList = Array.isArray(list) ? list.slice(0, 500) : []
    },
    setSuccessRates(rates = {}) {
      this.successRates = {
        playback: rates.playback != null ? Number(rates.playback) : this.successRates.playback,
        danmaku: rates.danmaku != null ? Number(rates.danmaku) : this.successRates.danmaku
      }
    },
    setSelectOptions({ rooms, sources } = {}) {
      if (Array.isArray(rooms) && rooms.length) {
        this.rooms = rooms
      }
      if (Array.isArray(sources) && sources.length) {
        this.sources = sources
      }
    },
    buildWatchTrendOption({ timestamps = [], values = [] } = {}) {
      return {
        tooltip: { trigger: 'axis' },
        grid: { left: 36, right: 12, top: 24, bottom: 30 },
        xAxis: { type: 'category', data: timestamps, boundaryGap: false },
        yAxis: { type: 'value', minInterval: 1 },
        series: [
          {
            name: '实时观看',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            areaStyle: { opacity: 0.18 },
            lineStyle: { width: 3 },
            data: values
          }
        ]
      }
    },
    buildSourceOption({ categories = [], series = [] } = {}) {
      return {
        tooltip: { trigger: 'axis' },
        grid: { left: 48, right: 12, top: 30, bottom: 40 },
        xAxis: { type: 'category', data: categories, axisTick: { alignWithLabel: true } },
        yAxis: { type: 'value', minInterval: 1 },
        series: [
          {
            name: '流量',
            type: 'bar',
            barWidth: '40%',
            itemStyle: { borderRadius: [4, 4, 0, 0] },
            data: series
          }
        ]
      }
    },
    buildDeviceOption(list = []) {
      return {
        tooltip: { trigger: 'item' },
        legend: { bottom: 0, textStyle: { color: '#a3b3d1' } },
        series: [
          {
            name: '设备占比',
            type: 'pie',
            radius: ['45%', '70%'],
            label: { color: '#e5eaf3' },
            data: list
          }
        ]
      }
    },
    buildRegionOption({ categories = [], series = [] } = {}) {
      return {
        tooltip: { trigger: 'axis' },
        grid: { left: 90, right: 20, top: 30, bottom: 30 },
        xAxis: { type: 'value', minInterval: 1 },
        yAxis: { type: 'category', data: categories, axisLabel: { color: '#e5eaf3' } },
        series: [
          {
            type: 'bar',
            data: series,
            barWidth: '45%',
            itemStyle: { borderRadius: [0, 6, 6, 0] }
          }
        ]
      }
    },
    buildBrowserOption(list = []) {
      return {
        tooltip: { trigger: 'item' },
        legend: { bottom: 0, textStyle: { color: '#a3b3d1' } },
        series: [
          {
            name: '浏览器占比',
            type: 'pie',
            radius: ['45%', '70%'],
            label: { color: '#e5eaf3' },
            data: list
          }
        ]
      }
    },
    BuildPlayInfoOption() {
      const vis = Array.isArray(this.visitsRaw) ? this.visitsRaw : [];
      if (!vis.length) { return { series: [{ type: 'pie', data: [] }] }; }

      const rows = vis.map(v => ({
        ok: v.play_ok === 1,
        region: this.bucketUSRegion((v.country || v.geo_country || ''), (v.region || v.geo_region || '')),
        os: this.detectOS(v),
        platform: this.detectPlatform(v),
        browser: this.bucketBrowser(v),
      }));

      const pass = (r) => {
        const rOk = !this.filterRegion.length || this.filterRegion.includes(r.region);
        const oOk = !this.filterOS.length || this.filterOS.includes(r.os);
        const pOk = !this.filterPlatform.length || this.filterPlatform.includes(r.platform);
        const bOk = !this.filterBrowser.length || this.filterBrowser.includes(r.browser);
        return rOk && oOk && pOk && bOk;
      };
      const filtered = rows.filter(pass);

      const map = new Map();
      for (const r of filtered) {
        const key = r[this.successDim];
        const rec = map.get(key) || { ok: 0, total: 0 };
        rec.total += 1;
        rec.ok += r.ok ? 1 : 0;
        map.set(key, rec);
      }
      const data = Array.from(map.entries())
        .map(([name, v]) => ({ name, value: v.ok, _ok: v.ok, _total: v.total, _rate: v.total ? (v.ok / v.total * 100) : 0 }))
        .filter(d => d._total > 0)
        .sort((a, b) => b.value - a.value);
      return {
        tooltip: { trigger: 'item', formatter: p => `${p.name}<br/>成功 ${p.data._ok}/${p.data._total}（${p.data._rate.toFixed(1)}%）` },
        legend: { orient: 'vertical', left: 20, top: 30, textStyle: { color: '#cfd7ff' }, type: 'scroll' },
        series: [{ type: 'pie', radius: ['35%', '70%'], label: { formatter: '{b}\n{d}%' }, data }]
      };
    },
    async loadRooms() {
      try {
        let start = new Date(Date.now() - 90 *24 *60 *60*1000).toLocaleString().replaceAll('/','-')
        const res = await liveroomsList(this.wokfoy_appid,100, 1,start)
        const list = res?.data?.data || res?.data || []
        if (!Array.isArray(list) || list.length === 0) return
        const routeRoom = String(this.$route.query.room || '').trim()
        const options = list.map(item => ({
          label: item.stream_name,
          value: item.stream_name,
          id: item.id,
          status: item.status
        }))
        this.setSelectOptions({ rooms: [{ label: '全部房间', value: '' }, ...options] })
        const active = list.find(item => item.stream_name === routeRoom) || list.find(item => item.status === 1) || list[0]
        if (active) {
          this.roomId = active.stream_name
          this.danmu_roomId = active.id
          if (routeRoom) {
            this.filters.room = routeRoom
          } else if (!this.filters.room) {
            this.filters.room = active.stream_name
          }
          this.updateVideoSource(active.stream_name)
        }
      } catch (err) {
        console.error('[BigScreen] loadRooms failed', err)
      }
    },
    updateVideoSource(room) {
      let is_living = this.rooms.find(f => room == f.value)?.status == 1
      // 将原来的 HLS 播放地址切换为 Agora 频道名
      if (!is_living) {
        this.videoSrc = ''
        return
      }
      const trimmed = String(room).trim()
      // 在当前实现中，videoSrc 直接代表 Agora 的频道名
      this.videoSrc = trimmed || ''
      this.room_id = trimmed || ''
    },
    formatNumber(value) {
      return Number(value || 0).toLocaleString()
    },
    formatDateTime(date) {
      const pad = n => String(n).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },
    formatTime(value) {
      const ts = this.parseTimestamp(value)
      if (ts == null) return '-'
      const d = new Date(ts)
      const pad = n => String(n).padStart(2, '0')
      return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    buildQueryParams({ limit = 500, offset = 0 } = {}) {
      // const params = new URLSearchParams()
      // params.set('limit', limit)
      // params.set('offset', offset)
      // if (Array.isArray(this.filters.range) && this.filters.range.length === 2) {
      //   const [start, end] = this.filters.range
      //   if (start) params.set('from', start)
      //   if (end) params.set('to', end)
      // }
      // if (this.filters.room) params.set('room_id', this.filters.room)
      // if (this.filters.source) params.set('source', this.filters.source)
      // return params.toString()
      const params = new URLSearchParams()

      if (Array.isArray(this.filters.range) && this.filters.range.length === 2) {
        const [start, end] = this.filters.range
        if (start) params.set('from', start)

        // const endTs = this.parseTimestamp(end)
        // const now = Date.now()
        const endTs = this.isRealtime ? new Date().toISOString() : this.filters.range[1]
        params.set('to', endTs)
      }

      if (this.filters.room) params.set('room_id', this.filters.room)
      if (this.filters.source) params.set('source', this.filters.source)

      // extra
      if (limit != null) params.set('limit', String(limit))
      if (offset != null) params.set('offset', String(offset))

      return params.toString()
    },

    async fetchVisits() {
      const base = this.apiBase
      // if (!base) throw new Error('统计接口地址未配置')
      const limit = 500
      const maxPages = 10
      const all = []
      let offset = 0
      for (let page = 0; page < maxPages; page++) {
        const query = this.buildQueryParams({ limit, offset })
        const data = await fetchLiveStatsJsonWithFallback(
          base,
          LIVE_STATS_PATHS.visits,
          LEGACY_LIVE_STATS_PATHS.visits,
          query
        )
        const items = Array.isArray(data.items) ? data.items.map(item => this.normalizeVisit(item)) : []
        all.push(...items)
        if (items.length < limit) break
        offset += limit
      }
      return all
    },
    // ===== 大屏快照（HTTP） =====
    // 优先调用新版 dashboard-snapshot，后端最多返回 5000 条。
    // 如果快照请求失败，则回退到访问明细分页拉取。
    async fetchDashboardSnapshot() {
      const base = this.apiBase
      // if (!base) throw new Error('统计接口地址未配置')

      const query = this.buildQueryParams({ limit: 5000, offset: 0 })
      try {
        this.room_id = this.filters.room
        this.danmu_roomId = this.rooms.find(f => f.value == this.filters.room)?.id
        const data = await fetchLiveStatsJsonWithFallback(
          base,
          LIVE_STATS_PATHS.dashboardSnapshot,
          LEGACY_LIVE_STATS_PATHS.dashboardSnapshot,
          query
        )
        const items = Array.isArray(data.items) ? data.items : []
        const visits = items.map(item => this.normalizeVisit(item))
        this.rebuildVisitIndex(visits)
        return visits
      } catch (e) {
        console.warn('[BigScreen] dashboard snapshot request failed, fallback to visits paging', e)
      }

      const visits = await this.fetchVisits()
      this.rebuildVisitIndex(visits)
      return visits
    },

    // 为增量合并建立 sid -> index 映射
    rebuildVisitIndex(visits = []) {
      try {
        this.visitIndex = new Map()
        visits.forEach((v, i) => {
          if (v && v.sid) this.visitIndex.set(String(v.sid), i)
        })
      } catch (e) {
        this.visitIndex = null
      }
    },

    // ===== SSE（实时增量） =====
    closeSSE() {
      if (this.sse) {
        try { this.sse.close() } catch (e) { }
        this.sse = null
      }
      if (this.recomputeTimer) {
        clearTimeout(this.recomputeTimer)
        this.recomputeTimer = null
      }
    },

    startSSE() {
      const base = (this.apiBase || '').replace(/\/$/, '')
      if (!base) return
      if (this.sse) return

      const url = buildLiveStatsUrl(base, LIVE_STATS_PATHS.stream)
      const es = new EventSource(url)
      this.sse = es

      es.addEventListener('hello', () => {
        // 可选：console.log('[BigScreen] SSE connected')
      })

      es.addEventListener('visit_delta', (ev) => {
        let delta = null
        try { delta = JSON.parse(ev.data || '{}') } catch (e) { delta = null }
        if (!delta || !delta.sid) return
        this.applyVisitDelta(delta)
        this.scheduleRecompute()
      })

      es.onerror = () => {
        // EventSource 会自动重连，这里不主动 close
        // 如需提示可以打开：
        // this.error = '实时连接中断，正在自动重连...'
      }
    },

    inCurrentRange(ts) {
      if (!ts) return true
      if (!Array.isArray(this.filters.range) || this.filters.range.length !== 2) return true

      const from = this.parseTimestamp(this.filters.range[0])
      const end = this.isRealtime ? Date.now() : this.parseTimestamp(this.filters.range[1])

      if (from && ts < from) return false
      if (end && ts > end) return false
      return true
    },
    buildExtraParsedFromDeltaExtra(extra) {
      const e = extra && typeof extra === 'object' ? extra : {}
      const safeArr = (v) => Array.isArray(v) ? v : (typeof v === 'string' ? (() => {
        try { const a = JSON.parse(v); return Array.isArray(a) ? a : [] } catch { return [] }
      })() : [])

      const safeObj = (v) => (v && typeof v === 'object' && !Array.isArray(v)) ? v : (typeof v === 'string' ? (() => {
        try { const o = JSON.parse(v); return (o && typeof o === 'object' && !Array.isArray(o)) ? o : {} } catch { return {} }
      })() : {})

      return {
        extra: e,
        file_logs: safeArr(e.file_logs),
        api_logs: safeArr(e.api_logs),
        webrtc_info: safeObj(e.webrtc_info),
        play_metrics: safeObj(e.play_metrics),
      }
    },
    applyVisitDelta(delta) {
      if (!delta || !delta.sid) return

      // delta.ts / delta.enter_ts / delta.exit_ts 任选其一
      const ts = delta.ts || delta.enter_ts || delta.exit_ts
      if (ts && !this.inCurrentRange(ts)) return

      const idx = this.visitsRaw.findIndex(v => v.sid === delta.sid)

      // 把 SSE 的 extra 补成 extra_parsed，保持和访问明细返回结构一致。
      const extra = (delta.extra && typeof delta.extra === 'object') ? delta.extra : {}
      const extra_parsed = this.buildExtraParsedFromDeltaExtra(extra)

      if (idx === -1) {
        const row = {
          sid: delta.sid,
          cid: delta.cid || '',
          enter_ts: delta.enter_ts || delta.ts || null,
          exit_ts: delta.exit_ts || null,
          duration_ms: delta.duration_ms || 0,
          ip: delta.ip || '',
          country: delta.country || '',
          region: delta.region || '',
          city: delta.city || '',
          ua: delta.ua || '',
          referer: delta.referer || '',
          room_id: delta.room_id || '',
          play_ok: delta.play_ok ?? null,

          // 关键：两套字段都补齐
          extra_json: extra,
          extra_parsed,
        }

        // Vue2：用 unshift 是响应式的
        this.visitsRaw.unshift(row)
        return
      }

      const prev = this.visitsRaw[idx] || {}

      const merged = {
        ...prev,
        ...delta,
        // 关键：保持两套字段一直存在
        extra_json: { ...(prev.extra_json || {}), ...extra },
        extra_parsed: prev.extra_parsed ? {
          ...prev.extra_parsed,
          ...extra_parsed,
          extra: { ...(prev.extra_parsed.extra || {}), ...extra }
        } : extra_parsed,
      }

      // Vue2：更新数组某个 index 必须用 this.$set，否则可能不触发视图更新
      this.$set(this.visitsRaw, idx, merged)
    },

    scheduleRecompute() {
      if (this.recomputeTimer) clearTimeout(this.recomputeTimer)
      this.recomputeTimer = setTimeout(() => {
        try {
          const visits = Array.isArray(this.visitsRaw) ? this.visitsRaw : []
          this.filterOptions = this.buildFilterOptionsFromVisits(visits)
          const summary = this.buildSummary(visits)
          this.watchMetrics = summary.watchMetrics || { watch3s: 0, watch15s: 0, watch60s: 0 }
          this.setKpis(summary.kpis)
          this.setChartData(summary.charts)
          this.setAbnormalList(summary.abnormalList)
          this.setSuccessRates(summary.successRates)
        } catch (e) {
          console.warn('[BigScreen] recompute failed', e)
        }
      }, this.recomputeDelayMs)
    },
    normalizeVisit(raw = {}) {
      const extra = raw.extra_json
      let parsed = {}
      if (typeof extra === 'string') {
        try {
          parsed = JSON.parse(extra) || {}
        } catch (err) {
          parsed = {}
        }
      } else if (extra && typeof extra === 'object') {
        parsed = extra
      }
      return {
        ...raw,
        extra_json: parsed,
        play_ok: this.resolveStatus(raw.play_ok),
        duration_ms: Number(raw.duration_ms) || 0,
        enter_ts: this.parseTimestamp(raw.enter_ts)
      }
    },
    resolveStatus(value) {
      if (value === null || value === undefined) return null
      if (typeof value === 'number') {
        if (value === 1) return 1
        if (value === 0) return 0
        return null
      }
      if (typeof value === 'boolean') return value ? 1 : 0
      if (typeof value === 'string') {
        const lower = value.trim().toLowerCase()
        if (['1', 'true', 'ok', 'success', 'yes'].includes(lower)) return 1
        if (['0', 'false', 'fail', 'failed', 'no', 'error'].includes(lower)) return 0
      }
      return null
    },
    parseTimestamp(value) {
      if (value === null || value === undefined) return null
      if (typeof value === 'number') {
        return Number.isNaN(value) ? null : value
      }
      if (value instanceof Date) return value.getTime()
      if (typeof value === 'string') {
        const num = Number(value)
        if (!Number.isNaN(num) && num > 1e9) return num
        const d = new Date(value)
        const ts = d.getTime()
        return Number.isNaN(ts) ? null : ts
      }
      return null
    },
    resolveBoolean(value) {
      if (value === null || value === undefined) return null
      if (typeof value === 'boolean') return value
      if (typeof value === 'number') {
        if (value === 1) return true
        if (value === 0) return false
        return null
      }
      if (typeof value === 'string') {
        const lower = value.trim().toLowerCase()
        if (['1', 'true', 'yes', 'y', 'ok', 'success'].includes(lower)) return true
        if (['0', 'false', 'no', 'n', 'fail', 'failed', 'error'].includes(lower)) return false
      }
      return null
    },
    detectSource(visit) {
      const rawReferer = visit.referer || visit.referrer || ''
      const utm = visit.utm_source || visit.extra_json?.utm_source || ''
      const combined = `${rawReferer} ${utm}`.toLowerCase()
      const mapping = [
        { label: 'tiktok', match: ['utm_source=tk', 'utm_source=tiktok', 'tiktok', 'douyin'] },
        { label: 'Facebook', match: ['utm_source=fb', 'utm_source=facebook', 'facebook'] },
        { label: 'YouTube', match: ['utm_source=yt', 'utm_source=youtube', 'youtube'] },
        { label: 'Pinterest', match: ['utm_source=pin', 'utm_source=pinterest', 'pinterest'] },
        { label: 'Google', match: ['utm_source=google', 'google'] },
        { label: 'X', match: ['utm_source=X', 'X', 'twitter'] },
        { label: 'ins', match: ['utm_source=instagram', 'ins', 'instagram'] },
        { label: 'snap', match: ['utm_source=snap', 'snap'] },
        { label: '广告', match: ['utm_source=ads', 'utm_medium=cpc', 'adset', 'adgroup'] }
      ]
      for (const item of mapping) {
        if (item.match.some(key => combined.includes(key))) return item.label
      }
      // if (rawReferer) {
      //   try {
      //     const url = new URL(rawReferer)
      //     return url.hostname.replace(/^www\./, '')
      //   } catch (err) {
      //     // ignore
      //   }
      // }
      return '其他'
    },
    detectDevice(visit) {
      const ua = (visit.ua || visit.user_agent || '').toLowerCase()
      if (!ua) return '未知'
      if (ua.includes('iphone') || ua.includes('ipad') || ua.includes('ios')) return 'iOS'
      if (ua.includes('android')) return 'Android'
      if (ua.includes('windows')) return 'Windows'
      if (ua.includes('mac os') || ua.includes('macintosh')) return 'Mac'
      if (ua.includes('linux')) return 'Linux'
      if (ua.includes('micromessenger')) return '微信内置'
      if (ua.includes('huawei')) return '华为'
      return '其他'
    },
    detectRegionKey(visit) {
      const country = (visit.country || visit.geo_country || '').toUpperCase()
      const region = visit.region || visit.geo_region || visit.city || ''
      const parts = [country, region].filter(Boolean)
      return parts.length ? parts.join('-') : '未知'
    },
    formatRegionLabel(visit) {
      const country = visit.country || visit.geo_country || ''
      const region = visit.region || visit.geo_region || visit.city || ''
      const parts = [country, region].filter(Boolean)
      return parts.length ? parts.join(' / ') : '-'
    },
    detectBrowser(visit) {
      const ua = (visit.ua || visit.user_agent || '').toLowerCase()
      if (!ua) return '未知'
      if (ua.includes('micromessenger')) return '微信内置'
      if (ua.includes('qqbrowser')) return 'QQ浏览器'
      if (ua.includes('ucbrowser')) return 'UC浏览器'
      if (ua.includes('edg')) return 'Edge'
      if (ua.includes('opr') || ua.includes('opera')) return 'Opera'
      if (ua.includes('firefox')) return 'Firefox'
      if (ua.includes('chrome') && !ua.includes('edg') && !ua.includes('opr')) return 'Chrome'
      if (ua.includes('safari') && ua.includes('WKWebview')) return 'TK内置'
      if (ua.includes('safari') && !ua.includes('chrome')) return 'Safari'
      return '其他'
    },
    buildMinuteBucket(ts) {
      const value = this.parseTimestamp(ts)
      if (value == null) return null
      const d = new Date(value)
      const pad = n => String(n).padStart(2, '0')
      return {
        label: `${pad(d.getHours())}:${pad(d.getMinutes())}`,
        order: Math.floor(value / 60000)
      }
    },
    mapTrendSeries(map) {
      const entries = Array.from(map.entries()).sort((a, b) => a[1].order - b[1].order)
      return {
        timestamps: entries.map(([label]) => label),
        values: entries.map(([, data]) => data.count)
      }
    },
    mapBarSeries(map, limit = 10) {
      const entries = Array.from(map.entries()).filter(([label]) => !!label)
      entries.sort((a, b) => b[1] - a[1])
      if (limit && entries.length > limit) {
        const head = entries.slice(0, limit - 1)
        const tail = entries.slice(limit - 1)
        const otherValue = tail.reduce((sum, [, val]) => sum + val, 0)
        if (otherValue > 0) {
          head.push(['其他', otherValue])
        }
        return {
          categories: head.map(([label]) => label),
          series: head.map(([, val]) => val)
        }
      }
      return {
        categories: entries.map(([label]) => label),
        series: entries.map(([, val]) => val)
      }
    },
    mapPieSeries(map, limit = 6) {
      const entries = Array.from(map.entries()).map(([label, value]) => [label || '未知', value])
      entries.sort((a, b) => b[1] - a[1])
      if (!limit || entries.length <= limit) {
        return entries.map(([name, value]) => ({ name, value }))
      }
      const head = entries.slice(0, limit - 1)
      const restValue = entries.slice(limit - 1).reduce((sum, [, val]) => sum + val, 0)
      const result = head.map(([name, value]) => ({ name, value }))
      if (restValue > 0) {
        result.push({ name: '其他', value: restValue })
      }
      return result
    },
    buildSummary(visits) {
      const uvSet = new Set()
      let sumDuration = 0
      let firstFrameSum = 0
      let firstFrameCount = 0
      let successCount = 0
      let successKnown = 0
      let danmakuOk = 0
      let danmakuTotal = 0
      let clickShoppingCart = 0
      let clickContact = 0

      // 观看分层（按单次访问停留时长 duration_ms 统计）
      let watch3s = 0
      let watch15s = 0
      let watch60s = 0

      const watchMap = new Map()
      const sourceMap = new Map()
      const deviceMap = new Map()
      const regionMap = new Map()
      const browserMap = new Map()
      const abnormal = []

      visits.forEach(visit => {
        const uvKey = visit.cid || visit.sid || visit.user_id || (visit.ip ? `${visit.ip}-${visit.ua || ''}` : null)
        if (uvKey) uvSet.add(uvKey)

        if (visit.play_ok === 1) {
          successCount += 1
          successKnown += 1
        } else {
          successKnown += 1
        }
        if (visit.extra_parsed.extra?.click_shoppingcart) clickShoppingCart += 1
        if (visit.extra_parsed.extra?.open_contact) clickContact += 1
        const danmuFlag = this.resolveBoolean(visit.extra_json?.danmu)
        if (danmuFlag !== null) {
          danmakuTotal += 1
          danmakuOk += 1
        } else {
          danmakuTotal += 1
        }

        const duration = Number(visit.duration_ms) || 0
        sumDuration += duration

        if (duration >= 3000) watch3s += 1
        if (duration >= 15000) watch15s += 1
        if (duration >= 60000) watch60s += 1

        const firstFrame = Number(visit.t_first ?? visit.extra_json?.t_first)
        if (!Number.isNaN(firstFrame) && firstFrame > 0) {
          firstFrameSum += firstFrame
          firstFrameCount += 1
        }

        const bucket = this.buildMinuteBucket(visit.enter_ts)
        if (bucket) {
          const entry = watchMap.get(bucket.label)
          if (entry) {
            entry.count += 1
          } else {
            watchMap.set(bucket.label, { count: 1, order: bucket.order })
          }
        }

        const source = this.detectSource(visit)
        sourceMap.set(source, (sourceMap.get(source) || 0) + 1)

        const device = this.detectDevice(visit)
        deviceMap.set(device, (deviceMap.get(device) || 0) + 1)

        const regionKey = this.detectRegionKey(visit)
        regionMap.set(regionKey, (regionMap.get(regionKey) || 0) + 1)

        const browser = this.detectBrowser(visit)
        browserMap.set(browser, (browserMap.get(browser) || 0) + 1)


        if (duration <= 3000 || visit.play_ok !== 1 || danmuFlag === false) {
          const reasonParts = []
          if (visit.play_ok === 0) reasonParts.push('播放失败')
          else if (visit.play_ok === null) reasonParts.push('播放未知')
          if (duration > 0 && duration <= 3000) reasonParts.push(`停留${(duration / 1000).toFixed(1)}s`)
          if (danmuFlag === false) reasonParts.push('弹幕未加载')
          const reason = reasonParts.join(' / ')
          if (reason) {
            abnormal.push({
              timestamp: this.formatTime(visit.enter_ts),
              ip: visit.ip || '-',
              region: this.formatRegionLabel(visit),
              device,
              reason
            })
          }
        }
      })

      const pv = visits.length
      const uv = uvSet.size
      const playbackRate = successKnown ? (successCount / successKnown) * 100 : 0
      const danmakuRate = danmakuTotal ? (danmakuOk / danmakuTotal) * 100 : 0
      let avgPullSeconds = 0
      if (firstFrameCount > 0) {
        avgPullSeconds = firstFrameSum / firstFrameCount / 1000
      } else if (pv > 0) {
        avgPullSeconds = sumDuration / pv / 1000
      }

      const watchTrend = this.mapTrendSeries(watchMap)
      const sourceBar = this.mapBarSeries(sourceMap, 8)
      const devicePie = this.mapPieSeries(deviceMap, 6)
      const regionBar = this.mapBarSeries(regionMap, 8)
      const browserPie = this.mapPieSeries(browserMap, 6)
      const abnormalList = abnormal.slice(0, 80)

      return {
        watchMetrics: { watch3s, watch15s, watch60s },
        kpis: [
          { key: 'uv', label: 'UV', value: uv, delta: 0 },
          { key: 'pv', label: 'PV', value: pv, delta: 0 },
          { key: 'pullSuccessRate', label: '拉流成功率', value: playbackRate, delta: 0 },
          { key: 'avgPullSeconds', label: '平均播放时长(s)', value: avgPullSeconds, delta: 0 },
          { key: 'danmuTotal', label: '弹幕总数', value: 0, delta: 0 },
          { key: 'shoppingCartTotal', label: '购物车点击', value: clickShoppingCart, delta: 0 },
          { key: 'contactTotal', label: '联系客服点击', value: clickContact, delta: 0 }
        ],
        charts: {
          watchTrend,
          sourceBar,
          devicePie,
          regionBar,
          browserPie
        },
        successRates: { playback: playbackRate, danmaku: danmakuRate },
        abnormalList
      }
    },
    async loadDashboardData() {
      this.loading = true
      this.error = ''
      try {
        let visits = await this.fetchDashboardSnapshot()
        visits = visits.filter(f => f.duration_ms > 2000 && f.room_id)
        if (!visits.length) {
          this.watchMetrics = { watch3s: 0, watch15s: 0, watch60s: 0 }
          this.setKpis([
            { key: 'uv', label: 'UV', value: 0, delta: 0 },
            { key: 'pv', label: 'PV', value: 0, delta: 0 },
            { key: 'pullSuccessRate', label: '拉流成功率', value: 0, delta: 0 },
            { key: 'avgPullSeconds', label: '平均拉流秒数', value: 0, delta: 0 },
            { key: 'danmuTotal', label: '弹幕总数', value: 0, delta: 0 },
            { key: 'shoppingCartTotal', label: '购物车点击', value: 0, delta: 0 },
            { key: 'contactTotal', label: '联系客服点击', value: 0, delta: 0 }
          ])
          this.setChartData({
            watchTrend: { timestamps: [], values: [] },
            sourceBar: { categories: [], series: [] },
            devicePie: [],
            regionBar: { categories: [], series: [] },
            browserPie: [],
            playinfoPie: []
          })
          this.setAbnormalList([])
          this.setSuccessRates({ playback: 0, danmaku: 0 })
          return
        }
        this.visitsRaw = Array.isArray(visits) ? visits.slice() : [];
        this.filterOptions = this.buildFilterOptionsFromVisits(visits);
        const summary = this.buildSummary(visits)
        this.watchMetrics = summary.watchMetrics || { watch3s: 0, watch15s: 0, watch60s: 0 }
        this.setKpis(summary.kpis)
        this.setChartData(summary.charts)
        this.setAbnormalList(summary.abnormalList)
        this.setSuccessRates(summary.successRates)
      } catch (err) {
        console.error('[BigScreen] loadDashboardData error', err)
        this.error = err.message || '数据加载失败'
        // this.bootstrapMockData()
      } finally {
        this.loading = false
      }
    },
    async setupVideo() {
      // 对接 Agora 播放器：当 videoSrc（房间名）变化时，作为观众加入对应频道
      if (!this.videoSrc) {
        await this.leaveAgoraChannel()
        return
      }
      await this.joinAgoraChannel(this.videoSrc)
    },

    async initAgoraClient() {
      console.log('[agora] leave called', new Date().toISOString())
      console.log('[agora] init client', new Date().toISOString())
      if (this.agoraClient) return
      if (!this.agora.appId) {
        console.warn('[BigScreen] 请先在环境变量中配置 VUE_APP_AGORA_APPID')
        return
      }
      const client = AgoraRTC.createClient({ mode: 'live', codec: 'h264' })
      client.setClientRole('audience')

      client.on('user-published', this.handleUserPublished)
      client.on('user-unpublished', this.handleUserUnpublished)
      client.on('connection-state-change', (cur, prev, reason) => {
        console.log('[agora] conn', prev, '->', cur, 'reason:', reason)
      })

      client.on('user-joined', (user) => {
        console.log('[agora] user-joined', user.uid)
      })

      client.on('user-left', (user) => {
        console.log('[agora] user-left', user.uid)
      })

      client.on('user-published', (user, mediaType) => {
        console.log('[agora] user-published', user.uid, mediaType)
      })
      this.agoraClient = client
    },
    async fetchToken(channel) {
      if (!this.tokenServer) {
        alert('未配置 Token 服务：请在 tokenServer 中填入你的服务地址或设置 VUE_APP_TOKEN_SERVER');
        throw new Error('token server missing');
      }
      this.loadingToken = true;
      try {
        const tokenData = await requestAgoraRtcToken({
          tokenServer: this.tokenServer,
          channel,
          role: 'audience',
          uid: this.agora.uid,
        })
        this.$set(this.agora, 'token', tokenData.token)
        this.$set(this.agora, 'appId', tokenData.appId)
        this.$set(this.agora, 'uid', tokenData.uid)
        this.$set(this.agora, 'uidMode', tokenData.uidMode || '')
        return tokenData
      } catch (e) {
        console.error(e);
        alert('获取 Token 失败');
        throw e;
      } finally {
        this.loadingToken = false;
      }
    },
    async joinAgoraChannel(channel) {
      channel = (channel || '').trim()
      if (!channel) return

      // 如果已经在这个频道里，就不要重复 join
      if (this.remoteJoined && this.joinedChannel === channel) {
        console.log('[agora] skip join (same channel)', channel)
        return
      }

      // 防止并发/重复触发
      if (this.joining) {
        console.log('[agora] skip join (joining in progress)', channel)
        return
      }

      this.joining = true
      const seq = ++this.joinSeq
      console.log('[agora] join start', { seq, channel })

      try {
        await this.initAgoraClient()

        // 只在确实切频道/已加入过时才 leave
        if (this.remoteJoined || this.joinedChannel) {
          await this.leaveAgoraChannel()
        }

        const tokenData = await this.fetchToken(channel)

        // 如果 join 过程中 channel 又变了，直接放弃这次 join
        if (seq !== this.joinSeq) {
          console.log('[agora] abort join (seq changed)', { seq, current: this.joinSeq })
          return
        }

        const token = tokenData.token || this.agora.token || null
        const uid = tokenData.uid != null ? tokenData.uid : this.agora.uid
        const appId = tokenData.appId || this.agora.appId
        console.log(appId, channel, token, uid)
        await this.agoraClient.join(appId, channel, token, uid)
        // ⭐补订阅：把已经存在的远端用户轨道拉起来
        for (const u of this.agoraClient.remoteUsers) {
          if (u.hasVideo) {
            await this.agoraClient.subscribe(u, 'video')
            u.videoTrack && u.videoTrack.play(this.$refs.agoraContainer)
          }
          if (u.hasAudio) {
            await this.agoraClient.subscribe(u, 'audio')
            u.audioTrack && u.audioTrack.play()
          }
        }
        console.log('[agora] remoteUsers', this.agoraClient.remoteUsers.map(u => ({
          uid: u.uid, hasVideo: u.hasVideo, hasAudio: u.hasAudio
        })))
        this.remoteJoined = true
        this.joinedChannel = channel
        console.log('[agora] joined ok', { seq, channel })
      } catch (e) {
        console.error('[agora] join failed', e)
      } finally {
        if (seq === this.joinSeq) this.joining = false
      }
    },
    async leaveAgoraChannel() {
      if (!this.agoraClient) return
      try {
        await this.agoraClient.leave()
      } catch (e) {
        // ignore
      }
      this.remoteJoined = false
      this.joinedChannel = ''
    },

    async handleUserPublished(user, mediaType) {
      console.log('[agora] user-published', user.uid, mediaType)
      if (!this.agoraClient) return
      try {
        await this.agoraClient.subscribe(user, mediaType)

        if (mediaType === 'video' && user.videoTrack) {
          const container = this.$refs.agoraContainer
          if (!container) return
          let player = document.getElementById(`agora-player-${user.uid}`)
          if (!player) {
            player = document.createElement('div')
            player.id = `agora-player-${user.uid}`
            player.style.width = '100%'
            player.style.height = '100%'
            container.innerHTML = ''
            container.appendChild(player)
          }
          user.videoTrack.play(player)
        }
        if (mediaType === 'audio' && user.audioTrack) {
          user.audioTrack.play()
        }
      } catch (err) {
        console.error('[BigScreen] subscribe remote user failed', err)
      }
    },

    handleUserUnpublished(user, mediaType) {
      if (mediaType === 'video') {
        const player = document.getElementById(`agora-player-${user.uid}`)
        if (player && player.parentNode) {
          player.parentNode.removeChild(player)
        }
      }
    }
  }
}
</script>
<style scoped>
body {
  background: radial-gradient(circle at top left, rgba(29, 78, 216, 0.16), transparent 40%),
    linear-gradient(140deg, #050b1a, #081126 55%, #040713 100%);
}

.bigscreen {
  padding: 12px;
  background: radial-gradient(circle at top left, rgba(29, 78, 216, 0.16), transparent 40%),
    linear-gradient(140deg, #050b1a, #081126 55%, #040713 100%);
  min-height: 100vh;
  color: #e5eaf3;
  box-sizing: border-box;
}

.bigscreen-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  margin-bottom: 12px;
  padding: 0 16px;
  border: 1px solid rgba(121, 162, 255, 0.28);
  border-radius: 12px;
  background: rgba(8, 17, 38, 0.9);
  color: #dce8ff;
  font-size: 14px;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.bigscreen-back:hover {
  border-color: rgba(121, 162, 255, 0.52);
  background: rgba(16, 30, 60, 0.96);
}

.toolbar {
  margin-bottom: 12px;
  background: rgba(10, 18, 32, 0.9);
  border: 1px solid #14203a;
}

.toolbar ::v-deep .el-form-item__label {
  color: #9fb4d3;
}

.error-alert {
  margin-bottom: 12px;
  background: rgba(255, 153, 0, 0.12);
  border: 1px solid rgba(255, 153, 0, 0.32);
  color: #ffcf8f;
}

.full {
  background: radial-gradient(circle at top left, rgba(29, 78, 216, 0.16), transparent 40%),
    linear-gradient(140deg, #050b1a, #081126 55%, #040713 100%);
  height: calc(100vh - 24px);
}

.left,
.right {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.left {
  overflow-y: scroll;
}

::-webkit-scrollbar {
  display: none;
}

.panel {
  background: rgba(10, 18, 32, 0.92);
  border: 1px solid #14203a;
  color: #e5eaf3;
  margin-bottom: 12px;

}

.right .panel ::v-deep .el-card__body {
  padding: 0;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-title {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.panel-substats {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #98a9c9;
}

.panel-substats strong {
  color: #53c3ff;
  margin-left: 6px;
}

.kpi-row {
  margin-bottom: 12px;
}

.kpi-card {
  position: relative;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(160deg, rgba(14, 53, 118, 0.5), rgba(9, 19, 42, 0.8));
  border: 1px solid rgba(64, 158, 255, 0.18);
}

.kpi-label {
  font-size: 13px;
  opacity: 0.78;
}

.kpi-value {
  font-size: 26px;
  font-weight: 700;
  margin-top: 6px;
}

.kpi-delta {
  position: absolute;
  top: 10px;
  right: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.08);
}

.kpi-delta.up {
  color: #67c23a;
}

.kpi-delta.down {
  color: #f56c6c;
}

.chart-card,
.table-card {
  flex: none;
}

.chart-grid {
  margin-bottom: 12px;
}

.watch-metrics-row {
  margin-bottom: 12px;
}

.watch-card {
  background: linear-gradient(160deg, rgba(14, 53, 118, 0.35), rgba(9, 19, 42, 0.88));
  border: 1px solid rgba(64, 158, 255, 0.18);
}

.watch-items {
  padding: 6px 4px;
}

.watch-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 6px;
  border-bottom: 1px dashed rgba(159, 180, 211, 0.18);
}

.watch-item:last-child {
  border-bottom: none;
}

.watch-label {
  color: #cfd7ff;
  opacity: 0.85;
  font-size: 13px;
}

.watch-value {
  font-size: 18px;
  font-weight: 700;
  color: #e5eaf3;
}

/* 原来的样式保持不动，只改了 video 区块相关 */

.video-panel {
  min-height: 120px;
  display: flex;
  flex-direction: column;
}

.video-panel ::v-deep .el-card__body {
  flex: 1;
  min-height: 0;
}

/* 有视频：比例盒 */
.video-wrap {
  position: relative;
  width: 100%;
  padding-bottom: 177.7%;
  background: #000;
  overflow: hidden;
}

/* 无视频：固定最小高度，不用 padding-bottom 撑 */
.video-wrap.empty {
  padding-bottom: 0;
  height: 120px;
}

.video-panel .agora-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
}

.danmaku-panel-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  /* ⭐关键 */
  overflow: hidden;
}

/* ElementUI 的 el-card__body 默认不是 flex，也没有高度，要改 */
.danmaku-panel-box ::v-deep .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  /* ⭐关键 */
}

/* 包裹 Danmaku 的容器也要能吃到高度 */
.danmaku-panel-box .danmaku-wrap {
  flex: 1;
  min-height: 0;
  /* ⭐关键：否则内部 list 不会滚动 */
  overflow: hidden;
}

.danmaku-empty {
  height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7a8ab0;
  font-size: 14px;
}

.right .panel:last-child {
  margin-bottom: 0;
}

.el-table {
  background: transparent;
}

.el-table::before {
  background: transparent;
}

.el-table th,
.el-table td {
  background: transparent;
  color: #e5eaf3;
}

.el-table th {
  color: #9fb4d3;
}

.my-loading .el-loading-spinner {
  top: 0;
  /* 距离容器顶部 */
  margin-top: 0 !important;
  /* 干掉默认的 -21px 之类的居中偏移 */
}
</style>
